import { render, staticRenderFns } from "./paypal-auth.vue?vue&type=template&id=2c49a405&scoped=true&"
import script from "./paypal-auth.vue?vue&type=script&lang=js&"
export * from "./paypal-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49a405",
  null
  
)

export default component.exports